import { lazy, Suspense } from 'react'

export const RoutesComponents = (props) => {
    const ComponentRender = lazy(() => import(`./components/${props.route}/${props.component}`))
    return (
        <Suspense fallback={<div><p className='text-gray-100'>{"Cargando..."}</p></div>}>
            <ComponentRender />
        </Suspense>
    )
}